/* tslint:disable */
/* eslint-disable */
// Generated using typescript-generator version 3.2.1263 on 2024-10-29 16:53:53.

export interface CreateAgentRequestDto {
    id: string;
    name: string;
    usesTill: boolean;
    usesVault: boolean;
    isActive: boolean;
    version: number;
}

export interface WebUUIDResponse {
    result: string; problemResponseData?: ProblemResponseData|null;
}

export interface CreateLocationRequestDto {
    id: string;
    name: string;
    agentId: string;
    isActive: boolean;
    opened: boolean;
    isDeleted: boolean;
    version: number;
}

export interface GetFilterdLocationsWithAggregatedTillsRequestDto {
    locationName: string;
    paginationData: PaginationRequestCommon;
    sortBy: string;
    ascending: boolean;
}

export interface CreateSubTillRequestDto {
    id: string;
    name: string;
    currencyCode: string;
    terminalId: string;
    serviceTypeCodes: string[];
    currencyTypes: string[];
    usesDenominations: boolean;
}

export interface WebBooleanResponse {
    result: boolean; problemResponseData?: ProblemResponseData|null;
}

export interface CreateSubTillMaximumRequestDto {
    amount: number;
    validFromDateTime: DateAsString;
    subTillId: string;
    documentId: string;
    documentName: string;
    messageWhenReached: string;
}

export interface CreateSubTillMaximumAlertRequestDto {
    subTillId: string;
    percentageAlert: boolean;
    alertValue: number;
    message: string;
}

export interface CreateSubTillMaximumForLocationRequestDto {
    amount: number;
    validFromDateTime: DateAsString;
    currency: string;
    documentId: string;
    documentName: string;
    messageWhenReached: string;
}

export interface CreateSubTillMaximumForServiceTypeRequestDto {
    amount: number;
    validFromDateTime: DateAsString;
    serviceType: string;
    currency: string;
    documentId: string;
    documentName: string;
    messageWhenReached: string;
}

export interface CreateSubTillMaximumForTerminalRequestDto {
    amount: number;
    validFromDateTime: DateAsString;
    currency: string;
    documentId: string;
    documentName: string;
    messageWhenReached: string;
}

export interface DeleteSubTillMaximumRequestDto {
    subTillId: string;
}

export interface DeleteSubTillMaximumAlertRequestDto {
    subTillId: string;
    subTillMaximumAlertId: string;
}

export interface UpdateSubTillMaximumRequestDto {
    subTillId: string;
    amount: number;
    validFromDateTime: DateAsString;
    documentId: string;
    documentName: string;
}

export interface UpdateSubTillMaximumAlertRequestDto {
    subTillId: string;
    subTillMaximumAlertId: string;
    percentageAlert: boolean;
    alertValue: number;
    message: string;
}

export interface CreateSubTillTransactionRequestDto {
    amount: number;
    transactionDirectionType: TransactionDirectionTypeEnum;
    referenceId: string;
    currencyCode: string;
    serviceTypeCode: string;
    currencyTypeId: string;
    denominations: SubTillTransactionDenominationRequestDto[];
    transactionTypeId: string;
    comment: string;
    inOutComment: string;
    outTransactionNumber: number;
    amountPerMainBankRate: number;
    amountPerBankRate: number;
    buyBankRate: number;
    sellBankRate: number;
    vaultId: string;
}

export interface CreateSubTillAutomaticTransferRequestDto {
    amount: number;
    currencyCode: string;
    serviceTypeCodeFrom: string;
    serviceTypeCodeTo: string;
    denominations: SubTillTransactionDenominationRequestDto[];
}

export interface SubTillTransactionSinceOpeningFiltersRequestDto {
    isRefund: boolean;
    currencyCode: string;
    serviceType: string;
    transactionTypeId: string;
    paginationData: PaginationRequestCommon;
    sortBy: string;
    ascending: boolean;
}

export interface GetAllSubTillTransactionsByTillIdSinceOpeningRequestDto {
    tillId: string;
    sortBy: string;
    ascending: boolean;
    paginationData: PaginationRequestCommon;
}

export interface SubTillTransactionsByTillIdFiltersRequestDto {
    dateTimeFrom: DateAsString;
    dateTimeTo: DateAsString;
    isRefund: boolean;
    currencyCode: string;
    serviceType: string;
    transactionTypeId: string;
    paginationData: PaginationRequestCommon;
    sortBy: string;
    ascending: boolean;
}

export interface RefundSubTillTransactionRequestDto {
    transactionId: string;
    refundReason: string;
    denominations: SubTillTransactionDenominationRequestDto[];
}

export interface CreateTerminalRequestDto {
    id: string;
    locationId: string;
    terminalName: string;
    terminalCode: string;
    tillName: string;
    tillId: string;
    isDeleted: boolean;
    isActive: boolean;
    version: number;
}

export interface GetTerminalsByLocationIdWithAggregatedTillsRequestDto {
    locationId: string;
    paginationData: PaginationRequestCommon;
    sortBy: string;
    ascending: boolean;
}

export interface CreateVaultRequestDto {
    connectedEntityId: string;
    name: string;
    vaultCode: string;
    vaultType: TillType;
}

export interface SetTillParentVaultRequestDto {
    parentTillId: string;
    childTillId: string;
}

export interface TillControlInputRequestDto {
    tillId: string;
}

export interface CreateCurrencyRequestDto {
    name: string;
    code: string;
    symbol: string;
}

export interface CreateCurrencyDenominationRequestDto {
    id: string;
    value: number;
    currencyCode: string;
    banknote: boolean;
    active: boolean;
}

export interface CreateMultipleCurrencyDenominationRequirementsRequestDto {
    requirements: CreateCurrencyDenominationRequirementRequestDto[];
}

export interface CreateCurrencyTypeRequestDto {
    name: string;
}

export interface CreateServiceTypeRequestDto {
    name: string;
    code: string;
}

export interface AddTransactionTypeToServiceTypeRequestDto {
    id: string;
    transactionTypeId: string;
}

export interface CreateTransactionTypeRequestDto {
    id: string;
    name: string;
    transactionGroupType: TransactionGroupTypeEnum;
    transactionDirectionType: TransactionDirectionTypeEnum;
    domesticCurrency: boolean;
    foreignCurrency: boolean;
    defaultForServiceType: boolean;
    generateInOutNumber: boolean;
    cancellation: boolean;
    exchangeTransactionType: ExchangeTransactionType;
}

export interface WebResponseObject<T> extends WebResponseBase {
    result: T;
}

export interface WebResponseEntity<T> {
    result: T; problemResponseData?: ProblemResponseData|null;
}

export interface GetAgentResponseDto {
    agent: AgentCommon;
}

export interface GetAllAgentsResponseDto {
    agents: AgentCommon[];
}

export interface GetAllLocationsByAgentIdResponseDto {
    locations: LocationCommon[];
}

export interface GetAllLocationsResponseDto {
    locations: LocationCommon[];
}

export interface PaginationRequestCommon {
    currentPage: number;
    itemsPerPage: number;
}

export interface GetFilteredLocationsWithAggregatedTillsResponseDto {
    locations: LocationWithAggregatedTillBalancesCommon[];
    totalCount: number;
}

export interface GetLocationResponseDto {
    location: LocationCommon;
}

export interface WebListResponseEntity<T> {
    result: T[]; problemResponseData?: ProblemResponseData|null;
}

export interface SubTillFlattenedCommon {
    id: string;
    name: string;
    balance: number;
    subTillMaximum: number;
    unlimited: boolean;
    limitPassed: boolean;
    active: boolean;
    tillId: string;
    currency: string;
    serviceTypes: string;
    currencyDenominationBalances: CurrencyDenominationBalanceFlattenedCommon[];
}

export interface GetAllSubTillsByTillIdResponseDto {
    subTills: SubTillCommon[];
}

export interface GetSubTillResponseDto {
    subTill: SubTillCommon;
}

export interface SubTillMaximumCommon {
    id: string;
    amount: number;
    validFromDateTime: DateAsString;
    subTillId: string;
    alerts: SubTillMaximumAlertCommon[];
}

export interface SubTillMaximumHistorySnapshotCommon {
    id: string;
    amount: number;
    activatedDateTime: DateAsString;
    deactivatedDateTime: DateAsString;
    documentId: string;
    subTillId: string;
}

export interface SubTillTransactionDenominationRequestDto {
    value: number;
    count: number;
    banknote: boolean;
    damaged: boolean;
}

export interface SubTillTransactionCommon {
    id: string;
    subTillId: string;
    locationName: string;
    amount: number;
    balance: number;
    transactionDateTime: DateAsString;
    referenceId: string;
    description: string;
    currencyCode: string;
    serviceTypeCode: string;
    currencyTypeId: string;
    transactionDirectionType: TransactionDirectionTypeEnum;
    transactionInOutNumber: number;
    inOutComment: string;
    relatedTransactionId: string;
    isRefund: boolean;
    isRefunded: boolean;
    refundedTransactionId: string;
    refundTransactionId: string;
    refundReason: string;
}

export interface BalanceCheckResponseDto {
    hasEnoughFunds: boolean;
    missingFunds: number;
    subTillsWithEnoughFunds: SubTillCommon[];
}

export interface WebPageResponseEntity<T> extends WebResponseEntity<GetPagingResponseDto<T>> {
    body: WebResponseObject<GetPagingResponseDto<T>>;
}

export interface GetAllSubTillTransactionsBySubTillIdResponseDto {
    subTillTransactions: SubTillTransactionCommon[];
}

export interface GetAllSubTillTransactionsByTillIdSinceOpeningResponseDto {
    subTillTransactions: SubTillTransactionCommon[];
    totalCount: number;
}

export interface GetSubTillTransactionResponseDto {
    subTillTransaction: SubTillTransactionCommon;
}

export interface GetAllTerminalsByLocationIdResponseDto {
    terminals: TerminalCommon[];
}

export interface GetTerminalsByLocationIdWithAggregatedTillsResponseDto {
    terminals: TerminalWithAggregatedTillBalancesCommon[];
    totalCount: number;
}

export interface GetAllTerminalsResponseDto {
    terminals: TerminalCommon[];
}

export interface GetTerminalResponseDto {
    terminal: TerminalCommon;
}

export interface GetAllTillControlRequestsRequestDto {
    tillControlRequests: TillControlRequestCommon[];
}

export interface GetTillControlRequestRequestDto {
    tillControlRequest: TillControlRequestCommon;
}

export interface TillCommon {
    id: string;
    name: string;
    terminalId: string;
    isOpen: boolean;
    operatorId: string;
    openedDateTime: DateAsString;
}

export interface TillVaultCommon {
    id: string;
    name: string;
    connectedEntityId: string;
    tillType: TillType;
    parentTill: TillVaultCommon;
    childTills: TillVaultCommon[];
}

export interface OpenTillResponseDto {
    till: TillCommon;
}

export interface AgentConfigurationCommon {
    id: string;
    agentId: string;
    internalTransactionPairingType: InternalTransactionPairingType;
}

export interface GetAllCurrenciesResponseDto {
    currencies: CurrencyCommon[];
}

export interface GetCurrencyResponseDto {
    currency: CurrencyCommon;
}

export interface CurrencyDenominationCommon {
    id: string;
    value: number;
    currencyCode: string;
    banknote: boolean;
    active: boolean;
}

export interface CurrencyDenominationRequirementCommon {
    id: string;
    agentId: string;
    requirementType: DenominationRequirementTypeEnum;
    currency: string;
    service: string;
}

export interface CreateCurrencyDenominationRequirementRequestDto {
    currency: string;
    service: string;
}

export interface GetAllCurrencyTypesResponseDto {
    currencyTypes: CurrencyTypeCommon[];
}

export interface GetCurrencyTypeResponseDto {
    currencyType: CurrencyTypeCommon;
}

export interface MasterAgentConfigurationCommon {
    id: string;
    tillOpeningStrategyType: TillOpeningStrategyType;
}

export interface GetAllMasterDataResponseDto {
    masterData: MasterDataCommon;
}

export interface GetAllServiceTypesResponseDto {
    serviceTypes: ServiceTypeCommon[];
}

export interface GetServiceTypeResponseDto {
    serviceType: ServiceTypeCommon;
}

export interface TransactionTypeCommon {
    id: string;
    name: string;
    domestic: boolean;
    foreign: boolean;
    transactionGroupType: TransactionGroupTypeEnum;
    type: TransactionDirectionTypeEnum;
    isDefault: boolean;
    exchangeTransactionType: ExchangeTransactionType;
}

export interface ProblemResponseData extends Serializable {
    error: boolean;
    problems: ProblemBase[];
}

export interface WebResponseBase extends Serializable {
    problemResponseData: ProblemResponseData;
}

export interface AgentCommon {
    id: string;
    name: string;
}

export interface LocationCommon {
    id: string;
    name: string;
}

export interface LocationWithAggregatedTillBalancesCommon {
    id: string;
    name: string;
    tillBalances: AggregatedTillBalanceCommon[];
}

export interface CurrencyDenominationBalanceFlattenedCommon {
    value: number;
    count: number;
    banknote: boolean;
    active: boolean;
}

export interface SubTillCommon {
    id: string;
    name: string;
    balance: number;
    coinBalance: number;
    banknoteBalance: number;
    damagedBalance: number;
    subTillMaximum: SubTillMaximumCommon;
    unlimited: boolean;
    limitPassed: boolean;
    active: boolean;
    tillId: string;
    currency: CurrencyCommon;
    serviceTypes: ServiceTypeCommon[];
    currencyTypeBalances: CurrencyTypeBalanceCommon[];
    currencyDenominationBalances: CurrencyDenominationBalanceCommon[];
    damagedCurrencyDenominationBalances: CurrencyDenominationBalanceCommon[];
    subTillBlueprintId: string;
}

export interface SubTillMaximumAlertCommon {
    id: string;
    percentage: boolean;
    amount: number;
    message: string;
}

export interface GetPagingResponseDto<T> {
    list: T[];
    totalCount: number;
}

export interface TerminalCommon {
    id: string;
    tillId: string;
    name: string;
}

export interface TerminalWithAggregatedTillBalancesCommon {
    id: string;
    name: string;
    tillBalances: AggregatedTillBalanceCommon[];
}

export interface TillControlRequestCommon {
    id: string;
    operatorId: string;
    tillId: string;
    requestDateTime: DateAsString;
    tillControlRequestType: TillControlRequestTypeEnum;
    tillBalanceSnapshot: TillBalanceSnapshotCommon;
}

export interface CurrencyCommon {
    id: string;
    name: string;
    code: string;
    currencyDenominations: CurrencyDenominationCommon[];
}

export interface CurrencyTypeCommon {
    id: string;
    name: string;
}

export interface MasterDataCommon {
    currencies: CurrencyCommon[];
    currencyTypes: CurrencyTypeCommon[];
    serviceTypes: ServiceTypeCommon[];
    transactionTypes: TransactionTypeCommon[];
}

export interface ServiceTypeCommon {
    id: string;
    name: string;
    code: string;
    transactionTypes: TransactionTypeCommon[];
}

export interface ProblemBase extends Serializable {
    problemCode: number;
    applicationOrigin: string;
    exceptionCode: string;
    message: string;
    details: string;
    type: string;
}

export interface Serializable {
}

export interface ResponseEntity<T> {
    result: T;
    problemResponseData?: ProblemResponseData|null;
}

export interface AggregatedTillBalanceCommon {
    currency: CurrencyCommon;
    amount: number;
}

export interface CurrencyTypeBalanceCommon {
    id: string;
    balance: number;
    currencyType: CurrencyTypeCommon;
    subTillId: string;
}

export interface CurrencyDenominationBalanceCommon {
    id: string;
    currencyDenomination: CurrencyDenominationCommon;
    count: number;
    isDamaged: boolean;
}

export interface TillBalanceSnapshotCommon {
    id: string;
    tillId: string;
    tillName: string;
    subTillBalanceSnapshots: SubTillBalanceSnapshotCommon[];
}

export interface SubTillBalanceSnapshotCommon {
    id: string;
    subTillId: string;
    subTillName: string;
    balance: number;
    currency: CurrencyCommon;
    currencyTypeBalanceSnapshots: CurrencyTypeBalanceSnapshotCommon[];
}

export interface HttpEntity<T> {
    headers: { [index: string]: string[] };
    body: T;
}

export interface CurrencyTypeBalanceSnapshotCommon {
    id: string;
    currencyTypeBalanceId: string;
    currencyType: CurrencyTypeCommon;
    balance: number;
}

export interface HttpClient<O> {

    request<R>(requestConfig: { method: string; url: string; queryParams?: any; data?: any; copyFn?: (data: R) => R; options?: O; }): RestResponse<R>;
}

export class RestApplicationClient<O> {

    constructor(protected httpClient: HttpClient<O>) {
    }

    /**
     * HTTP GET /till/agent-configuration/get
     * Java method: com.europoint.till.web.controllers.masterdata.AgentConfigurationController.getConfiguration
     */
    getConfiguration$GET$till_agentconfiguration_get(options?: O): RestResponse<WebResponseEntity<AgentConfigurationCommon>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`till/agent-configuration/get`, options: options });
    }

    /**
     * HTTP POST /till/agent-configuration/set-internal-transaction-pairing
     * Java method: com.europoint.till.web.controllers.masterdata.AgentConfigurationController.setInternalTransactionPairing
     */
    setInternalTransactionPairing(queryParams: { internalTransactionPairingType: InternalTransactionPairingType; }, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`till/agent-configuration/set-internal-transaction-pairing`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /till/agent/create
     * Java method: com.europoint.till.web.controllers.AgentController.addAgent
     */
    addAgent(createAgentRequestDto: CreateAgentRequestDto, options?: O): RestResponse<WebUUIDResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`till/agent/create`, data: createAgentRequestDto, options: options });
    }

    /**
     * HTTP GET /till/agent/get-all
     * Java method: com.europoint.till.web.controllers.AgentController.getAllAgents
     */
    getAllAgents(options?: O): RestResponse<WebResponseEntity<GetAllAgentsResponseDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`till/agent/get-all`, options: options });
    }

    /**
     * HTTP GET /till/agent/get/{ID}
     * Java method: com.europoint.till.web.controllers.AgentController.getAgent
     */
    getAgent(ID: string, options?: O): RestResponse<WebResponseEntity<GetAgentResponseDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`till/agent/get/${ID}`, options: options });
    }

    /**
     * HTTP POST /till/currency-denomination/create
     * Java method: com.europoint.till.web.controllers.masterdata.CurrencyDenominationController.addCurrencyDenomination
     */
    addCurrencyDenomination(createDenominationDto: CreateCurrencyDenominationRequestDto, options?: O): RestResponse<WebUUIDResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`till/currency-denomination/create`, data: createDenominationDto, options: options });
    }

    /**
     * HTTP GET /till/currency-denomination/get-all
     * Java method: com.europoint.till.web.controllers.masterdata.CurrencyDenominationController.getAllCurrencyDenominations
     */
    getAllCurrencyDenominations(options?: O): RestResponse<WebListResponseEntity<CurrencyDenominationCommon>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`till/currency-denomination/get-all`, options: options });
    }

    /**
     * HTTP GET /till/currency-denomination/get-all-requirements-for-agent
     * Java method: com.europoint.till.web.controllers.masterdata.CurrencyDenominationController.getAllRequirementsForAgent
     */
    getAllRequirementsForAgent(options?: O): RestResponse<WebListResponseEntity<CurrencyDenominationRequirementCommon>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`till/currency-denomination/get-all-requirements-for-agent`, options: options });
    }

    /**
     * HTTP GET /till/currency-denomination/get-all-requirements-for-master-agent
     * Java method: com.europoint.till.web.controllers.masterdata.CurrencyDenominationController.getAllRequirementsForMasterAgent
     */
    getAllRequirementsForMasterAgent(options?: O): RestResponse<WebListResponseEntity<CurrencyDenominationRequirementCommon>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`till/currency-denomination/get-all-requirements-for-master-agent`, options: options });
    }

    /**
     * HTTP GET /till/currency-denomination/get-by-currency-code/{CODE}
     * Java method: com.europoint.till.web.controllers.masterdata.CurrencyDenominationController.getCurrencyDenominationsByCurrencyCode
     */
    getCurrencyDenominationsByCurrencyCode(CODE: string, options?: O): RestResponse<WebListResponseEntity<CurrencyDenominationCommon>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`till/currency-denomination/get-by-currency-code/${CODE}`, options: options });
    }

    /**
     * HTTP GET /till/currency-denomination/get/{ID}
     * Java method: com.europoint.till.web.controllers.masterdata.CurrencyDenominationController.getCurrencyDenomination
     */
    getCurrencyDenomination(ID: string, options?: O): RestResponse<WebResponseEntity<CurrencyDenominationCommon>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`till/currency-denomination/get/${ID}`, options: options });
    }

    /**
     * HTTP POST /till/currency-denomination/update-requirements-for-agent
     * Java method: com.europoint.till.web.controllers.masterdata.CurrencyDenominationController.updateRequirementsForAgent
     */
    updateRequirementsForAgent(createMultipleRequirementsDto: CreateMultipleCurrencyDenominationRequirementsRequestDto, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`till/currency-denomination/update-requirements-for-agent`, data: createMultipleRequirementsDto, options: options });
    }

    /**
     * HTTP POST /till/currency-denomination/update-requirements-for-master-agent
     * Java method: com.europoint.till.web.controllers.masterdata.CurrencyDenominationController.updateRequirementsForMasterAgent
     */
    updateRequirementsForMasterAgent(createRequirementDto: CreateMultipleCurrencyDenominationRequirementsRequestDto, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`till/currency-denomination/update-requirements-for-master-agent`, data: createRequirementDto, options: options });
    }

    /**
     * HTTP POST /till/currency-type/create
     * Java method: com.europoint.till.web.controllers.masterdata.CurrencyTypeController.addCurrencyType
     */
    addCurrencyType(currencyTypeDto: CreateCurrencyTypeRequestDto, options?: O): RestResponse<WebUUIDResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`till/currency-type/create`, data: currencyTypeDto, options: options });
    }

    /**
     * HTTP GET /till/currency-type/get-all
     * Java method: com.europoint.till.web.controllers.masterdata.CurrencyTypeController.getAllCurrencyTypes
     */
    getAllCurrencyTypes(options?: O): RestResponse<WebResponseEntity<GetAllCurrencyTypesResponseDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`till/currency-type/get-all`, options: options });
    }

    /**
     * HTTP GET /till/currency-type/get/{ID}
     * Java method: com.europoint.till.web.controllers.masterdata.CurrencyTypeController.getCurrencyType
     */
    getCurrencyType(ID: string, options?: O): RestResponse<WebResponseEntity<GetCurrencyTypeResponseDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`till/currency-type/get/${ID}`, options: options });
    }

    /**
     * HTTP POST /till/currency/create
     * Java method: com.europoint.till.web.controllers.masterdata.CurrencyController.addCurrency
     */
    addCurrency(createCurrencyRequestDto: CreateCurrencyRequestDto, options?: O): RestResponse<WebUUIDResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`till/currency/create`, data: createCurrencyRequestDto, options: options });
    }

    /**
     * HTTP GET /till/currency/get-all
     * Java method: com.europoint.till.web.controllers.masterdata.CurrencyController.getAllCurrencies
     */
    getAllCurrencies(options?: O): RestResponse<WebResponseEntity<GetAllCurrenciesResponseDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`till/currency/get-all`, options: options });
    }

    /**
     * HTTP GET /till/currency/get-by-code/{CODE}
     * Java method: com.europoint.till.web.controllers.masterdata.CurrencyController.getCurrencyByCode
     */
    getCurrencyByCode$GET$till_currency_getbycode_CODE(CODE: string, options?: O): RestResponse<WebResponseEntity<GetCurrencyResponseDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`till/currency/get-by-code/${CODE}`, options: options });
    }

    /**
     * HTTP GET /till/currency/get-by-id/{ID}
     * Java method: com.europoint.till.web.controllers.masterdata.CurrencyController.getCurrencyById
     */
    getCurrencyById$GET$till_currency_getbyid_ID(ID: string, options?: O): RestResponse<WebResponseEntity<GetCurrencyResponseDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`till/currency/get-by-id/${ID}`, options: options });
    }

    /**
     * HTTP POST /till/location/create
     * Java method: com.europoint.till.web.controllers.LocationController.addLocation
     */
    addLocation(createLocationRequestDto: CreateLocationRequestDto, options?: O): RestResponse<WebUUIDResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`till/location/create`, data: createLocationRequestDto, options: options });
    }

    /**
     * HTTP POST /till/location/filter-by-location-name
     * Java method: com.europoint.till.web.controllers.LocationController.getAllLocationsFilteredByLocationName
     */
    getAllLocationsFilteredByLocationName(getFilterdLocationsWithAggregatedTillsRequestDto: GetFilterdLocationsWithAggregatedTillsRequestDto, options?: O): RestResponse<WebResponseEntity<GetFilteredLocationsWithAggregatedTillsResponseDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`till/location/filter-by-location-name`, data: getFilterdLocationsWithAggregatedTillsRequestDto, options: options });
    }

    /**
     * HTTP GET /till/location/get-all
     * Java method: com.europoint.till.web.controllers.LocationController.getAllLocations
     */
    getAllLocations(options?: O): RestResponse<WebResponseEntity<GetAllLocationsResponseDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`till/location/get-all`, options: options });
    }

    /**
     * HTTP GET /till/location/get-all-by-agent-id/{ID}
     * Java method: com.europoint.till.web.controllers.LocationController.getAllByAgentId
     */
    getAllByAgentId(ID: string, options?: O): RestResponse<WebResponseEntity<GetAllLocationsByAgentIdResponseDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`till/location/get-all-by-agent-id/${ID}`, options: options });
    }

    /**
     * HTTP GET /till/location/get/{ID}
     * Java method: com.europoint.till.web.controllers.LocationController.getLocation
     */
    getLocation(ID: string, options?: O): RestResponse<WebResponseEntity<GetLocationResponseDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`till/location/get/${ID}`, options: options });
    }

    /**
     * HTTP GET /till/master-agent-configuration/get
     * Java method: com.europoint.till.web.controllers.masterdata.MasterAgentConfigurationController.getConfiguration
     */
    getConfiguration$GET$till_masteragentconfiguration_get(options?: O): RestResponse<WebResponseEntity<MasterAgentConfigurationCommon>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`till/master-agent-configuration/get`, options: options });
    }

    /**
     * HTTP POST /till/master-agent-configuration/set-till-opening-strategy
     * Java method: com.europoint.till.web.controllers.masterdata.MasterAgentConfigurationController.setTillOpeningStrategy
     */
    setTillOpeningStrategy(queryParams: { tillOpeningStrategyType: TillOpeningStrategyType; }, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`till/master-agent-configuration/set-till-opening-strategy`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /till/master-data/get-all
     * Java method: com.europoint.till.web.controllers.masterdata.MasterDataController.getAllMasterData
     */
    getAllMasterData(options?: O): RestResponse<WebResponseEntity<GetAllMasterDataResponseDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`till/master-data/get-all`, options: options });
    }

    /**
     * HTTP POST /till/service-type/add-transaction-type
     * Java method: com.europoint.till.web.controllers.masterdata.ServiceTypeController.addTransactionType
     */
    addTransactionType$POST$till_servicetype_addtransactiontype(addTransactionTypeToServiceTypeRequestDto: AddTransactionTypeToServiceTypeRequestDto, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`till/service-type/add-transaction-type`, data: addTransactionTypeToServiceTypeRequestDto, options: options });
    }

    /**
     * HTTP POST /till/service-type/create
     * Java method: com.europoint.till.web.controllers.masterdata.ServiceTypeController.addServiceType
     */
    addServiceType(serviceTypeDto: CreateServiceTypeRequestDto, options?: O): RestResponse<WebUUIDResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`till/service-type/create`, data: serviceTypeDto, options: options });
    }

    /**
     * HTTP GET /till/service-type/get-all
     * Java method: com.europoint.till.web.controllers.masterdata.ServiceTypeController.getAllServiceTypes
     */
    getAllServiceTypes(options?: O): RestResponse<WebResponseEntity<GetAllServiceTypesResponseDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`till/service-type/get-all`, options: options });
    }

    /**
     * HTTP GET /till/service-type/get-by-code/{CODE}
     * Java method: com.europoint.till.web.controllers.masterdata.ServiceTypeController.getCurrencyByCode
     */
    getCurrencyByCode$GET$till_servicetype_getbycode_CODE(CODE: string, options?: O): RestResponse<WebResponseEntity<GetServiceTypeResponseDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`till/service-type/get-by-code/${CODE}`, options: options });
    }

    /**
     * HTTP GET /till/service-type/get-by-id/{ID}
     * Java method: com.europoint.till.web.controllers.masterdata.ServiceTypeController.getCurrencyById
     */
    getCurrencyById$GET$till_servicetype_getbyid_ID(ID: string, options?: O): RestResponse<WebResponseEntity<GetServiceTypeResponseDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`till/service-type/get-by-id/${ID}`, options: options });
    }

    /**
     * HTTP POST /till/sub-till-maximum/create
     * Java method: com.europoint.till.web.controllers.SubTillMaximumController.addSubTillMaximum
     */
    addSubTillMaximum(subTillMaximumDto: CreateSubTillMaximumRequestDto, options?: O): RestResponse<WebUUIDResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`till/sub-till-maximum/create`, data: subTillMaximumDto, options: options });
    }

    /**
     * HTTP POST /till/sub-till-maximum/create-alert
     * Java method: com.europoint.till.web.controllers.SubTillMaximumController.addSubTillMaximumAlert
     */
    addSubTillMaximumAlert(subTillMaximumAlertDto: CreateSubTillMaximumAlertRequestDto, options?: O): RestResponse<WebUUIDResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`till/sub-till-maximum/create-alert`, data: subTillMaximumAlertDto, options: options });
    }

    /**
     * HTTP POST /till/sub-till-maximum/create-for-location
     * Java method: com.europoint.till.web.controllers.SubTillMaximumController.addSubTillMaximumByLocationIdAndCurrency
     */
    addSubTillMaximumByLocationIdAndCurrency(subTillMaximumDto: CreateSubTillMaximumForLocationRequestDto, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`till/sub-till-maximum/create-for-location`, data: subTillMaximumDto, options: options });
    }

    /**
     * HTTP POST /till/sub-till-maximum/create-for-service-type
     * Java method: com.europoint.till.web.controllers.SubTillMaximumController.addSubTillMaximumByServiceTypeAndCurrency
     */
    addSubTillMaximumByServiceTypeAndCurrency(subTillMaximumDto: CreateSubTillMaximumForServiceTypeRequestDto, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`till/sub-till-maximum/create-for-service-type`, data: subTillMaximumDto, options: options });
    }

    /**
     * HTTP POST /till/sub-till-maximum/create-for-terminal
     * Java method: com.europoint.till.web.controllers.SubTillMaximumController.addSubTillMaximumForTerminalAndCurrency
     */
    addSubTillMaximumForTerminalAndCurrency(subTillMaximumDto: CreateSubTillMaximumForTerminalRequestDto, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`till/sub-till-maximum/create-for-terminal`, data: subTillMaximumDto, options: options });
    }

    /**
     * HTTP POST /till/sub-till-maximum/delete
     * Java method: com.europoint.till.web.controllers.SubTillMaximumController.deleteSubTillMaximum
     */
    deleteSubTillMaximum(deleteSubTillMaximumRequestDto: DeleteSubTillMaximumRequestDto, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`till/sub-till-maximum/delete`, data: deleteSubTillMaximumRequestDto, options: options });
    }

    /**
     * HTTP POST /till/sub-till-maximum/delete-alert
     * Java method: com.europoint.till.web.controllers.SubTillMaximumController.deleteSubTillMaximumAlert
     */
    deleteSubTillMaximumAlert(deleteSubTillMaximumAlertRequestDto: DeleteSubTillMaximumAlertRequestDto, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`till/sub-till-maximum/delete-alert`, data: deleteSubTillMaximumAlertRequestDto, options: options });
    }

    /**
     * HTTP GET /till/sub-till-maximum/get-by-sub-till-id/{ID}
     * Java method: com.europoint.till.web.controllers.SubTillMaximumController.getBySubTillId
     */
    getBySubTillId(ID: string, options?: O): RestResponse<WebResponseEntity<SubTillMaximumCommon>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`till/sub-till-maximum/get-by-sub-till-id/${ID}`, options: options });
    }

    /**
     * HTTP GET /till/sub-till-maximum/get-history-by-sub-till-id/{ID}
     * Java method: com.europoint.till.web.controllers.SubTillMaximumController.getHistoryBySubTillId
     */
    getHistoryBySubTillId(ID: string, options?: O): RestResponse<WebListResponseEntity<SubTillMaximumHistorySnapshotCommon>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`till/sub-till-maximum/get-history-by-sub-till-id/${ID}`, options: options });
    }

    /**
     * HTTP GET /till/sub-till-maximum/get/{ID}
     * Java method: com.europoint.till.web.controllers.SubTillMaximumController.getSubTillLimit
     */
    getSubTillLimit(ID: string, options?: O): RestResponse<WebResponseEntity<SubTillMaximumCommon>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`till/sub-till-maximum/get/${ID}`, options: options });
    }

    /**
     * HTTP POST /till/sub-till-maximum/update
     * Java method: com.europoint.till.web.controllers.SubTillMaximumController.updateSubTillMaximum
     */
    updateSubTillMaximum(updateSubTillMaximumRequestDto: UpdateSubTillMaximumRequestDto, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`till/sub-till-maximum/update`, data: updateSubTillMaximumRequestDto, options: options });
    }

    /**
     * HTTP POST /till/sub-till-maximum/update-alert
     * Java method: com.europoint.till.web.controllers.SubTillMaximumController.updateSubTillMaximumAlert
     */
    updateSubTillMaximumAlert(updateSubTillMaximumAlertRequestDto: UpdateSubTillMaximumAlertRequestDto, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`till/sub-till-maximum/update-alert`, data: updateSubTillMaximumAlertRequestDto, options: options });
    }

    /**
     * HTTP POST /till/sub-till-transaction/check-if-enough-funds
     * Java method: com.europoint.till.web.controllers.SubTillTransactionController.checkIfEnoughFunds
     */
    checkIfEnoughFunds(subTillTransactionDto: CreateSubTillTransactionRequestDto, options?: O): RestResponse<WebResponseEntity<BalanceCheckResponseDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`till/sub-till-transaction/check-if-enough-funds`, data: subTillTransactionDto, options: options });
    }

    /**
     * HTTP POST /till/sub-till-transaction/create
     * Java method: com.europoint.till.web.controllers.SubTillTransactionController.addSubTillTransaction
     */
    addSubTillTransaction(subTillTransactionDto: CreateSubTillTransactionRequestDto, options?: O): RestResponse<WebResponseEntity<SubTillTransactionCommon>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`till/sub-till-transaction/create`, data: subTillTransactionDto, options: options });
    }

    /**
     * HTTP POST /till/sub-till-transaction/create-transfer
     * Java method: com.europoint.till.web.controllers.SubTillTransactionController.createTransfer
     */
    createTransfer(subTillAutomaticTransferRequestDto: CreateSubTillAutomaticTransferRequestDto, options?: O): RestResponse<WebListResponseEntity<SubTillTransactionCommon>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`till/sub-till-transaction/create-transfer`, data: subTillAutomaticTransferRequestDto, options: options });
    }

    /**
     * HTTP GET /till/sub-till-transaction/get-all-by-sub-till-id-since-opening/{ID}
     * Java method: com.europoint.till.web.controllers.SubTillTransactionController.getAllBySubTillIdSinceOpening
     */
    getAllBySubTillIdSinceOpening(ID: string, options?: O): RestResponse<WebResponseEntity<any>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`till/sub-till-transaction/get-all-by-sub-till-id-since-opening/${ID}`, options: options });
    }

    /**
     * HTTP GET /till/sub-till-transaction/get-all-by-sub-till-id/{ID}
     * Java method: com.europoint.till.web.controllers.SubTillTransactionController.getAllSubTillTransactionsByTillId
     */
    getAllSubTillTransactionsByTillId(ID: string, options?: O): RestResponse<WebResponseEntity<GetAllSubTillTransactionsBySubTillIdResponseDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`till/sub-till-transaction/get-all-by-sub-till-id/${ID}`, options: options });
    }

    /**
     * HTTP POST /till/sub-till-transaction/get-all-since-opening-by-filters
     * Java method: com.europoint.till.web.controllers.SubTillTransactionController.getAllSinceOpeningByFilters
     */
    getAllSinceOpeningByFilters(request: SubTillTransactionSinceOpeningFiltersRequestDto, options?: O): RestResponse<WebPageResponseEntity<SubTillTransactionCommon>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`till/sub-till-transaction/get-all-since-opening-by-filters`, data: request, options: options });
    }

    /**
     * HTTP POST /till/sub-till-transaction/get-all-sub-till-transactions-by-till-id-since-opening-for-agent
     * Java method: com.europoint.till.web.controllers.SubTillTransactionController.getAllSubTillTransactionsByTillIdSinceOpeningForAgent
     */
    getAllSubTillTransactionsByTillIdSinceOpeningForAgent(getAllSubTillTransactionsByTillIdSinceOpeningRequestDto: GetAllSubTillTransactionsByTillIdSinceOpeningRequestDto, options?: O): RestResponse<WebResponseEntity<GetAllSubTillTransactionsByTillIdSinceOpeningResponseDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`till/sub-till-transaction/get-all-sub-till-transactions-by-till-id-since-opening-for-agent`, data: getAllSubTillTransactionsByTillIdSinceOpeningRequestDto, options: options });
    }

    /**
     * HTTP POST /till/sub-till-transaction/get-all-sub-till-transactions-by-till-id-since-opening-for-platform-operator
     * Java method: com.europoint.till.web.controllers.SubTillTransactionController.getAllSubTillTransactionsByTillIdSinceOpeningForPlatformOperator
     */
    getAllSubTillTransactionsByTillIdSinceOpeningForPlatformOperator(getAllSubTillTransactionsByTillIdSinceOpeningRequestDto: GetAllSubTillTransactionsByTillIdSinceOpeningRequestDto, options?: O): RestResponse<WebResponseEntity<GetAllSubTillTransactionsByTillIdSinceOpeningResponseDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`till/sub-till-transaction/get-all-sub-till-transactions-by-till-id-since-opening-for-platform-operator`, data: getAllSubTillTransactionsByTillIdSinceOpeningRequestDto, options: options });
    }

    /**
     * HTTP GET /till/sub-till-transaction/get-by-in-out-number/{inOutNumber}
     * Java method: com.europoint.till.web.controllers.SubTillTransactionController.getByInOutNumber
     */
    getByInOutNumber(inOutNumber: number, options?: O): RestResponse<WebResponseEntity<SubTillTransactionCommon>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`till/sub-till-transaction/get-by-in-out-number/${inOutNumber}`, options: options });
    }

    /**
     * HTTP POST /till/sub-till-transaction/get-sub-till-transactions-by-filters
     * Java method: com.europoint.till.web.controllers.SubTillTransactionController.getSubTillTransactionsByFilters
     */
    getSubTillTransactionsByFilters(subTillTransactionsByTillIdFiltersRequestDto: SubTillTransactionsByTillIdFiltersRequestDto, options?: O): RestResponse<WebPageResponseEntity<SubTillTransactionCommon>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`till/sub-till-transaction/get-sub-till-transactions-by-filters`, data: subTillTransactionsByTillIdFiltersRequestDto, options: options });
    }

    /**
     * HTTP GET /till/sub-till-transaction/get/{ID}
     * Java method: com.europoint.till.web.controllers.SubTillTransactionController.getSubTillTransaction
     */
    getSubTillTransaction(ID: string, options?: O): RestResponse<WebResponseEntity<GetSubTillTransactionResponseDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`till/sub-till-transaction/get/${ID}`, options: options });
    }

    /**
     * HTTP POST /till/sub-till-transaction/refund
     * Java method: com.europoint.till.web.controllers.SubTillTransactionController.refundSubTillTransaction
     */
    refundSubTillTransaction(refundSubTillTransactionRequestDto: RefundSubTillTransactionRequestDto, options?: O): RestResponse<WebResponseEntity<SubTillTransactionCommon>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`till/sub-till-transaction/refund`, data: refundSubTillTransactionRequestDto, options: options });
    }

    /**
     * HTTP POST /till/sub-till/create
     * Java method: com.europoint.till.web.controllers.SubTillController.addSubTill
     */
    addSubTill(createSubTillRequestDto: CreateSubTillRequestDto, options?: O): RestResponse<WebUUIDResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`till/sub-till/create`, data: createSubTillRequestDto, options: options });
    }

    /**
     * HTTP DELETE /till/sub-till/deactivate/{ID}
     * Java method: com.europoint.till.web.controllers.SubTillController.deactivate
     */
    deactivate$DELETE$till_subtill_deactivate_ID(ID: string, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "DELETE", url: uriEncoding`till/sub-till/deactivate/${ID}`, options: options });
    }

    /**
     * HTTP GET /till/sub-till/get-all-by-till-id/{ID}
     * Java method: com.europoint.till.web.controllers.SubTillController.getAllSubTillsByTillId
     */
    getAllSubTillsByTillId(ID: string, options?: O): RestResponse<WebResponseEntity<GetAllSubTillsByTillIdResponseDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`till/sub-till/get-all-by-till-id/${ID}`, options: options });
    }

    /**
     * HTTP GET /till/sub-till/get-all-flattened-by-till-id/{ID}
     * Java method: com.europoint.till.web.controllers.SubTillController.getAllFlattenedSubTillsByTillId
     */
    getAllFlattenedSubTillsByTillId(ID: string, options?: O): RestResponse<WebListResponseEntity<SubTillFlattenedCommon>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`till/sub-till/get-all-flattened-by-till-id/${ID}`, options: options });
    }

    /**
     * HTTP GET /till/sub-till/get-all-for-terminal
     * Java method: com.europoint.till.web.controllers.SubTillController.getAllSubTillsForTerminal
     */
    getAllSubTillsForTerminal(options?: O): RestResponse<WebResponseEntity<GetAllSubTillsByTillIdResponseDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`till/sub-till/get-all-for-terminal`, options: options });
    }

    /**
     * HTTP GET /till/sub-till/get/{ID}
     * Java method: com.europoint.till.web.controllers.SubTillController.getSubTill
     */
    getSubTill(ID: string, options?: O): RestResponse<WebResponseEntity<GetSubTillResponseDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`till/sub-till/get/${ID}`, options: options });
    }

    /**
     * HTTP POST /till/terminal/create
     * Java method: com.europoint.till.web.controllers.TerminalController.addTerminal
     */
    addTerminal(createTerminalRequestDto: CreateTerminalRequestDto, options?: O): RestResponse<WebUUIDResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`till/terminal/create`, data: createTerminalRequestDto, options: options });
    }

    /**
     * HTTP GET /till/terminal/get-all
     * Java method: com.europoint.till.web.controllers.TerminalController.getAllTerminals
     */
    getAllTerminals(options?: O): RestResponse<WebResponseEntity<GetAllTerminalsResponseDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`till/terminal/get-all`, options: options });
    }

    /**
     * HTTP POST /till/terminal/get-all-by-location-id-with-aggregated-tills
     * Java method: com.europoint.till.web.controllers.TerminalController.getAllByLocationIdWithAggregatedTills
     */
    getAllByLocationIdWithAggregatedTills(getTerminalsByLocationIdWithAggregatedTillsRequestDto: GetTerminalsByLocationIdWithAggregatedTillsRequestDto, options?: O): RestResponse<WebResponseEntity<GetTerminalsByLocationIdWithAggregatedTillsResponseDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`till/terminal/get-all-by-location-id-with-aggregated-tills`, data: getTerminalsByLocationIdWithAggregatedTillsRequestDto, options: options });
    }

    /**
     * HTTP GET /till/terminal/get-all-by-location-id/{ID}
     * Java method: com.europoint.till.web.controllers.TerminalController.getAllByLocationId
     */
    getAllByLocationId(ID: string, options?: O): RestResponse<WebResponseEntity<GetAllTerminalsByLocationIdResponseDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`till/terminal/get-all-by-location-id/${ID}`, options: options });
    }

    /**
     * HTTP GET /till/terminal/get/{ID}
     * Java method: com.europoint.till.web.controllers.TerminalController.getTerminal
     */
    getTerminal(ID: string, options?: O): RestResponse<WebResponseEntity<GetTerminalResponseDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`till/terminal/get/${ID}`, options: options });
    }

    /**
     * HTTP GET /till/till-control-request/get-all-by-till-id/{ID}
     * Java method: com.europoint.till.web.controllers.TillControlRequestController.getAllTillControlRequestsByTillId
     */
    getAllTillControlRequestsByTillId(ID: string, options?: O): RestResponse<WebResponseEntity<GetAllTillControlRequestsRequestDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`till/till-control-request/get-all-by-till-id/${ID}`, options: options });
    }

    /**
     * HTTP GET /till/till-control-request/get/{ID}
     * Java method: com.europoint.till.web.controllers.TillControlRequestController.getTillControlRequest
     */
    getTillControlRequest(ID: string, options?: O): RestResponse<WebResponseEntity<GetTillControlRequestRequestDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`till/till-control-request/get/${ID}`, options: options });
    }

    /**
     * HTTP POST /till/till/close
     * Java method: com.europoint.till.web.controllers.TillController.closeTill
     */
    closeTill(tillControlInputRequestDto: TillControlInputRequestDto, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`till/till/close`, data: tillControlInputRequestDto, options: options });
    }

    /**
     * HTTP POST /till/till/create-vault
     * Java method: com.europoint.till.web.controllers.TillController.addVault
     */
    addVault$POST$till_till_createvault(createVaultRequestDto: CreateVaultRequestDto, options?: O): RestResponse<WebUUIDResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`till/till/create-vault`, data: createVaultRequestDto, options: options });
    }

    /**
     * HTTP GET /till/till/get-all-by-agent-id/{ID}
     * Java method: com.europoint.till.web.controllers.TillController.getAllTillsByAgentId
     */
    getAllTillsByAgentId(ID: string, options?: O): RestResponse<WebListResponseEntity<TillCommon>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`till/till/get-all-by-agent-id/${ID}`, options: options });
    }

    /**
     * HTTP GET /till/till/get-by-terminal-id/{ID}
     * Java method: com.europoint.till.web.controllers.TillController.getTillByTerminalId
     */
    getTillByTerminalId(ID: string, options?: O): RestResponse<WebResponseEntity<TillCommon>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`till/till/get-by-terminal-id/${ID}`, options: options });
    }

    /**
     * HTTP GET /till/till/get-for-user
     * Java method: com.europoint.till.web.controllers.TillController.getTillForUser
     */
    getTillForUser(options?: O): RestResponse<WebResponseEntity<TillCommon>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`till/till/get-for-user`, options: options });
    }

    /**
     * HTTP GET /till/till/get-vault-by-agent-id/{AGENTID}
     * Java method: com.europoint.till.web.controllers.TillController.getVaultByAgentId
     */
    getVaultByAgentId(AGENTID: string, options?: O): RestResponse<WebResponseEntity<TillVaultCommon>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`till/till/get-vault-by-agent-id/${AGENTID}`, options: options });
    }

    /**
     * HTTP GET /till/till/get-with-vault-structure/{ID}
     * Java method: com.europoint.till.web.controllers.TillController.getTillWithVaultStructure
     */
    getTillWithVaultStructure(ID: string, options?: O): RestResponse<WebResponseEntity<TillVaultCommon>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`till/till/get-with-vault-structure/${ID}`, options: options });
    }

    /**
     * HTTP GET /till/till/get/{ID}
     * Java method: com.europoint.till.web.controllers.TillController.getTill
     */
    getTill(ID: string, options?: O): RestResponse<WebResponseEntity<TillCommon>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`till/till/get/${ID}`, options: options });
    }

    /**
     * HTTP POST /till/till/open
     * Java method: com.europoint.till.web.controllers.TillController.openTill
     */
    openTill(tillControlInputRequestDto: TillControlInputRequestDto, options?: O): RestResponse<WebResponseEntity<OpenTillResponseDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`till/till/open`, data: tillControlInputRequestDto, options: options });
    }

    /**
     * HTTP POST /till/till/set-parent-vault
     * Java method: com.europoint.till.web.controllers.TillController.addVault
     */
    addVault$POST$till_till_setparentvault(setTillParentVaultRequestDto: SetTillParentVaultRequestDto, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`till/till/set-parent-vault`, data: setTillParentVaultRequestDto, options: options });
    }

    /**
     * HTTP PUT /till/transaction-type/activate/{ID}
     * Java method: com.europoint.till.web.controllers.masterdata.TransactionTypeController.activate
     */
    activate(ID: string, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "PUT", url: uriEncoding`till/transaction-type/activate/${ID}`, options: options });
    }

    /**
     * HTTP POST /till/transaction-type/create
     * Java method: com.europoint.till.web.controllers.masterdata.TransactionTypeController.addTransactionType
     */
    addTransactionType$POST$till_transactiontype_create(transactionTypeDto: CreateTransactionTypeRequestDto, options?: O): RestResponse<WebUUIDResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`till/transaction-type/create`, data: transactionTypeDto, options: options });
    }

    /**
     * HTTP PUT /till/transaction-type/deactivate/{ID}
     * Java method: com.europoint.till.web.controllers.masterdata.TransactionTypeController.deactivate
     */
    deactivate$PUT$till_transactiontype_deactivate_ID(ID: string, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "PUT", url: uriEncoding`till/transaction-type/deactivate/${ID}`, options: options });
    }

    /**
     * HTTP GET /till/transaction-type/get-all-by-service-type-code/{CODE}
     * Java method: com.europoint.till.web.controllers.masterdata.TransactionTypeController.getAllTransactionTypesByServiceTypeId
     */
    getAllTransactionTypesByServiceTypeId$GET$till_transactiontype_getallbyservicetypecode_CODE(CODE: string, options?: O): RestResponse<WebListResponseEntity<TransactionTypeCommon>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`till/transaction-type/get-all-by-service-type-code/${CODE}`, options: options });
    }

    /**
     * HTTP GET /till/transaction-type/get-all-by-service-type-id/{ID}
     * Java method: com.europoint.till.web.controllers.masterdata.TransactionTypeController.getAllTransactionTypesByServiceTypeId
     */
    getAllTransactionTypesByServiceTypeId$GET$till_transactiontype_getallbyservicetypeid_ID(ID: string, options?: O): RestResponse<WebListResponseEntity<TransactionTypeCommon>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`till/transaction-type/get-all-by-service-type-id/${ID}`, options: options });
    }

    /**
     * HTTP GET /till/transaction-type/get/{ID}
     * Java method: com.europoint.till.web.controllers.masterdata.TransactionTypeController.getTransactionType
     */
    getTransactionType(ID: string, options?: O): RestResponse<WebResponseEntity<TransactionTypeCommon>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`till/transaction-type/get/${ID}`, options: options });
    }
}

export type RestResponse<R> = Promise<Axios.GenericAxiosResponse<R>>;

export type DateAsString = string;

export const enum InternalTransactionPairingType {
    PAIR = "PAIR",
    DONT_PAIR = "DONT_PAIR",
}

export const enum TillOpeningStrategyType {
    MANUAL = "MANUAL",
    AUTOMATIC = "AUTOMATIC",
}

/**
 * Values:
 * - `CONTINUE`
 * - `SWITCHING_PROTOCOLS`
 * - `PROCESSING`
 * - `CHECKPOINT`
 * - `OK`
 * - `CREATED`
 * - `ACCEPTED`
 * - `NON_AUTHORITATIVE_INFORMATION`
 * - `NO_CONTENT`
 * - `RESET_CONTENT`
 * - `PARTIAL_CONTENT`
 * - `MULTI_STATUS`
 * - `ALREADY_REPORTED`
 * - `IM_USED`
 * - `MULTIPLE_CHOICES`
 * - `MOVED_PERMANENTLY`
 * - `FOUND`
 * - `MOVED_TEMPORARILY` - @deprecated
 * - `SEE_OTHER`
 * - `NOT_MODIFIED`
 * - `USE_PROXY` - @deprecated
 * - `TEMPORARY_REDIRECT`
 * - `PERMANENT_REDIRECT`
 * - `BAD_REQUEST`
 * - `UNAUTHORIZED`
 * - `PAYMENT_REQUIRED`
 * - `FORBIDDEN`
 * - `NOT_FOUND`
 * - `METHOD_NOT_ALLOWED`
 * - `NOT_ACCEPTABLE`
 * - `PROXY_AUTHENTICATION_REQUIRED`
 * - `REQUEST_TIMEOUT`
 * - `CONFLICT`
 * - `GONE`
 * - `LENGTH_REQUIRED`
 * - `PRECONDITION_FAILED`
 * - `PAYLOAD_TOO_LARGE`
 * - `REQUEST_ENTITY_TOO_LARGE` - @deprecated
 * - `URI_TOO_LONG`
 * - `REQUEST_URI_TOO_LONG` - @deprecated
 * - `UNSUPPORTED_MEDIA_TYPE`
 * - `REQUESTED_RANGE_NOT_SATISFIABLE`
 * - `EXPECTATION_FAILED`
 * - `I_AM_A_TEAPOT`
 * - `INSUFFICIENT_SPACE_ON_RESOURCE` - @deprecated
 * - `METHOD_FAILURE` - @deprecated
 * - `DESTINATION_LOCKED` - @deprecated
 * - `UNPROCESSABLE_ENTITY`
 * - `LOCKED`
 * - `FAILED_DEPENDENCY`
 * - `TOO_EARLY`
 * - `UPGRADE_REQUIRED`
 * - `PRECONDITION_REQUIRED`
 * - `TOO_MANY_REQUESTS`
 * - `REQUEST_HEADER_FIELDS_TOO_LARGE`
 * - `UNAVAILABLE_FOR_LEGAL_REASONS`
 * - `INTERNAL_SERVER_ERROR`
 * - `NOT_IMPLEMENTED`
 * - `BAD_GATEWAY`
 * - `SERVICE_UNAVAILABLE`
 * - `GATEWAY_TIMEOUT`
 * - `HTTP_VERSION_NOT_SUPPORTED`
 * - `VARIANT_ALSO_NEGOTIATES`
 * - `INSUFFICIENT_STORAGE`
 * - `LOOP_DETECTED`
 * - `BANDWIDTH_LIMIT_EXCEEDED`
 * - `NOT_EXTENDED`
 * - `NETWORK_AUTHENTICATION_REQUIRED`
 */
export const enum HttpStatus {
    CONTINUE = "CONTINUE",
    SWITCHING_PROTOCOLS = "SWITCHING_PROTOCOLS",
    PROCESSING = "PROCESSING",
    CHECKPOINT = "CHECKPOINT",
    OK = "OK",
    CREATED = "CREATED",
    ACCEPTED = "ACCEPTED",
    NON_AUTHORITATIVE_INFORMATION = "NON_AUTHORITATIVE_INFORMATION",
    NO_CONTENT = "NO_CONTENT",
    RESET_CONTENT = "RESET_CONTENT",
    PARTIAL_CONTENT = "PARTIAL_CONTENT",
    MULTI_STATUS = "MULTI_STATUS",
    ALREADY_REPORTED = "ALREADY_REPORTED",
    IM_USED = "IM_USED",
    MULTIPLE_CHOICES = "MULTIPLE_CHOICES",
    MOVED_PERMANENTLY = "MOVED_PERMANENTLY",
    FOUND = "FOUND",
    /**
     * @deprecated
     */
    MOVED_TEMPORARILY = "MOVED_TEMPORARILY",
    SEE_OTHER = "SEE_OTHER",
    NOT_MODIFIED = "NOT_MODIFIED",
    /**
     * @deprecated
     */
    USE_PROXY = "USE_PROXY",
    TEMPORARY_REDIRECT = "TEMPORARY_REDIRECT",
    PERMANENT_REDIRECT = "PERMANENT_REDIRECT",
    BAD_REQUEST = "BAD_REQUEST",
    UNAUTHORIZED = "UNAUTHORIZED",
    PAYMENT_REQUIRED = "PAYMENT_REQUIRED",
    FORBIDDEN = "FORBIDDEN",
    NOT_FOUND = "NOT_FOUND",
    METHOD_NOT_ALLOWED = "METHOD_NOT_ALLOWED",
    NOT_ACCEPTABLE = "NOT_ACCEPTABLE",
    PROXY_AUTHENTICATION_REQUIRED = "PROXY_AUTHENTICATION_REQUIRED",
    REQUEST_TIMEOUT = "REQUEST_TIMEOUT",
    CONFLICT = "CONFLICT",
    GONE = "GONE",
    LENGTH_REQUIRED = "LENGTH_REQUIRED",
    PRECONDITION_FAILED = "PRECONDITION_FAILED",
    PAYLOAD_TOO_LARGE = "PAYLOAD_TOO_LARGE",
    /**
     * @deprecated
     */
    REQUEST_ENTITY_TOO_LARGE = "REQUEST_ENTITY_TOO_LARGE",
    URI_TOO_LONG = "URI_TOO_LONG",
    /**
     * @deprecated
     */
    REQUEST_URI_TOO_LONG = "REQUEST_URI_TOO_LONG",
    UNSUPPORTED_MEDIA_TYPE = "UNSUPPORTED_MEDIA_TYPE",
    REQUESTED_RANGE_NOT_SATISFIABLE = "REQUESTED_RANGE_NOT_SATISFIABLE",
    EXPECTATION_FAILED = "EXPECTATION_FAILED",
    I_AM_A_TEAPOT = "I_AM_A_TEAPOT",
    /**
     * @deprecated
     */
    INSUFFICIENT_SPACE_ON_RESOURCE = "INSUFFICIENT_SPACE_ON_RESOURCE",
    /**
     * @deprecated
     */
    METHOD_FAILURE = "METHOD_FAILURE",
    /**
     * @deprecated
     */
    DESTINATION_LOCKED = "DESTINATION_LOCKED",
    UNPROCESSABLE_ENTITY = "UNPROCESSABLE_ENTITY",
    LOCKED = "LOCKED",
    FAILED_DEPENDENCY = "FAILED_DEPENDENCY",
    TOO_EARLY = "TOO_EARLY",
    UPGRADE_REQUIRED = "UPGRADE_REQUIRED",
    PRECONDITION_REQUIRED = "PRECONDITION_REQUIRED",
    TOO_MANY_REQUESTS = "TOO_MANY_REQUESTS",
    REQUEST_HEADER_FIELDS_TOO_LARGE = "REQUEST_HEADER_FIELDS_TOO_LARGE",
    UNAVAILABLE_FOR_LEGAL_REASONS = "UNAVAILABLE_FOR_LEGAL_REASONS",
    INTERNAL_SERVER_ERROR = "INTERNAL_SERVER_ERROR",
    NOT_IMPLEMENTED = "NOT_IMPLEMENTED",
    BAD_GATEWAY = "BAD_GATEWAY",
    SERVICE_UNAVAILABLE = "SERVICE_UNAVAILABLE",
    GATEWAY_TIMEOUT = "GATEWAY_TIMEOUT",
    HTTP_VERSION_NOT_SUPPORTED = "HTTP_VERSION_NOT_SUPPORTED",
    VARIANT_ALSO_NEGOTIATES = "VARIANT_ALSO_NEGOTIATES",
    INSUFFICIENT_STORAGE = "INSUFFICIENT_STORAGE",
    LOOP_DETECTED = "LOOP_DETECTED",
    BANDWIDTH_LIMIT_EXCEEDED = "BANDWIDTH_LIMIT_EXCEEDED",
    NOT_EXTENDED = "NOT_EXTENDED",
    NETWORK_AUTHENTICATION_REQUIRED = "NETWORK_AUTHENTICATION_REQUIRED",
}

export const enum TransactionDirectionTypeEnum {
    PAY_IN = "PAY_IN",
    PAY_OUT = "PAY_OUT",
}

export const enum TillType {
    AGENT_VAULT = "AGENT_VAULT",
    REGION_VAULT = "REGION_VAULT",
    LOCATION_VAULT = "LOCATION_VAULT",
    REGULAR_TILL = "REGULAR_TILL",
}

export const enum TransactionGroupTypeEnum {
    BUSINESS = "BUSINESS",
    GENERAL = "GENERAL",
    INTERNAL = "INTERNAL",
    SPECIFIC = "SPECIFIC",
}

export const enum ExchangeTransactionType {
    NOT_EXCHANGE = "NOT_EXCHANGE",
    BUY_EFFECTIVE_DOMESTIC = "BUY_EFFECTIVE_DOMESTIC",
    BUY_EFFECTIVE_FOREIGN = "BUY_EFFECTIVE_FOREIGN",
    BUY_EFFECTIVE_DAMAGED = "BUY_EFFECTIVE_DAMAGED",
    BUY_EFFECTIVE_EXPIRED = "BUY_EFFECTIVE_EXPIRED",
    SELL_EFFECTIVE = "SELL_EFFECTIVE",
}

export const enum DenominationRequirementTypeEnum {
    AGENT = "AGENT",
    MASTER_AGENT = "MASTER_AGENT",
}

export const enum TillControlRequestTypeEnum {
    OPEN = "OPEN",
    CLOSE = "CLOSE",
}

function uriEncoding(template: TemplateStringsArray, ...substitutions: any[]): string {
    let result = "";
    for (let i = 0; i < substitutions.length; i++) {
        result += template[i];
        result += encodeURIComponent(substitutions[i]);
    }
    result += template[template.length - 1];
    return result;
}


// Added by 'AxiosClientExtension' extension

import axios from "axios";
import * as Axios from "axios";

declare module "axios" {
    export interface GenericAxiosResponse<R> extends Axios.AxiosResponse {
        data: R;
    }
}

class AxiosHttpClient implements HttpClient<Axios.AxiosRequestConfig> {

    constructor(private axios: Axios.AxiosInstance) {
    }

    request<R>(requestConfig: { method: string; url: string; queryParams?: any; data?: any; copyFn?: (data: R) => R; options?: Axios.AxiosRequestConfig; }): RestResponse<R> {
        function assign(target: any, source?: any) {
            if (source != undefined) {
                for (const key in source) {
                    if (source.hasOwnProperty(key)) {
                        target[key] = source[key];
                    }
                }
            }
            return target;
        }

        const config: Axios.AxiosRequestConfig = {};
        config.method = requestConfig.method as typeof config.method;  // `string` in axios 0.16.0, `Method` in axios 0.19.0
        config.url = requestConfig.url;
        config.params = requestConfig.queryParams;
        config.data = requestConfig.data;
        assign(config, requestConfig.options);
        const copyFn = requestConfig.copyFn;

        const axiosResponse = this.axios.request(config);
        return axiosResponse.then(axiosResponse => {
            if (copyFn && axiosResponse.data) {
                (axiosResponse as any).originalData = axiosResponse.data;
                axiosResponse.data = copyFn(axiosResponse.data);
            }
            return axiosResponse;
        });
    }
}

export class AxiosRestApplicationClient extends RestApplicationClient<Axios.AxiosRequestConfig> {

    constructor(baseURL: string, axiosInstance: Axios.AxiosInstance = axios.create()) {
        axiosInstance.defaults.baseURL = baseURL;
        super(new AxiosHttpClient(axiosInstance));
    }
}
